/*
 * COCODÍ — FAQ accordion toggle
 * The FAQ page body (admin Pages → FAQ) ships its own HTML + CSS but no JS.
 * Shopify strips <script> from page content, so the toggle lives here and is
 * loaded only on /pages/faq (see sections/main-page.liquid). Event delegation
 * means it works for every .faq-item, including any the client adds later.
 */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.faq-question');
    if (!button) return;

    var item = button.closest('.faq-item');
    if (!item) return;

    var isOpen = item.classList.toggle('open');
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
})();
